import { Buffer } from "buffer";
import CryptoJS from "crypto-js";
import {
    byteArrayToWordArray,
    generateChecksum,
    wordArrayToByteArray
} from './crypto/binary'

export const getAccountId = (principal) => {

    const sha = CryptoJS.algo.SHA224.create();
    sha.update('\x0Aaccount-id'); // Internally parsed with UTF-8, like go does
    sha.update(byteArrayToWordArray(principal.toUint8Array()));
    const subBuffer = Buffer.from(Buffer.alloc(32));

    sha.update(byteArrayToWordArray(subBuffer));
    const hash = sha.finalize();

    /// While this is backed by an array of length 28, it's canonical representation
    /// is a hex string of length 64. The first 8 characters are the CRC-32 encoded
    /// hash of the following 56 characters of hex. Both, upper and lower case
    /// characters are valid in the input string and can even be mixed.
    /// [ic/rs/rosetta-api/ledger_canister/src/account_identifier.rs]
    const byteArray = wordArrayToByteArray(hash, 28);
    const checksum = generateChecksum(byteArray);
    const val = checksum + hash.toString();

    return val;

}

export function fromHexString(hexString){

    return new Uint8Array((hexString.match(/.{1,2}/g) ?? []).map(byte => parseInt(byte, 16)))
}


export function showModelView(id){

    let div = document.getElementById(id)
    if (div !== undefined){

        div.style.opacity = 1
        div.style.zIndex = 1055
    }
}

export function hideModelView(id) {

    let div = document.getElementById(id)
    if (div !== undefined){

        div.style.opacity = 0
        div.style.zIndex = -1
    }
}